import { Grid, GridItem, IconButton, Button } from '@chakra-ui/react'
import { useCallback } from 'react'
import { AiOutlineCloseSquare } from 'react-icons/ai'
import { IoMdArrowBack } from 'react-icons/io'
import { DialerStateType } from '../contact-center.store'

type ControlProps = {
  setCurrentNumber: (n: string) => void
  currentNumber: string
  setDialerState: any
  dialerState: DialerStateType
  connectCall?: (d: DialerStateType) => void
}

export const KeyPadControls: React.FC<ControlProps> = ({
  setCurrentNumber,
  currentNumber,
  setDialerState,
  connectCall,
  dialerState,
}) => {
  const deleteLast = useCallback(() => {
    setCurrentNumber(currentNumber?.slice(0, -1))
  }, [currentNumber])

  const goBack = useCallback(() => {
    setDialerState(prev => ({ ...prev, isOpen: false }))
  }, [dialerState])

  const handleCall = useCallback(() => {
    //setDialerState(prev => ({ ...prev, isOpen: false, isCalling: true }))

    connectCall && connectCall(dialerState)
  }, [dialerState])
  return (
    <Grid templateColumns="repeat(3, 84px)" columnGap="14%" mt="25px">
      <GridItem>
        <IconButton
          variant="unstyled"
          aria-label="go back to contacts"
          icon={<IoMdArrowBack />}
          fontSize="32px"
          maxW="84px !important"
          minW="84px !important"
          display="flex"
          justifyContent="space-evenly"
          onClick={goBack}
        />
      </GridItem>
      <GridItem>
        <Button colorScheme="brand" onClick={handleCall}>
          Call
        </Button>
      </GridItem>
      <GridItem>
        {currentNumber?.length >= 1 && (
          <IconButton
            variant="unstyled"
            aria-label="remove dialed digit"
            icon={<AiOutlineCloseSquare />}
            fontSize="32px"
            maxW="84px !important"
            minW="84px !important"
            display="flex"
            justifyContent="space-evenly"
            onClick={deleteLast}
          />
        )}
      </GridItem>
    </Grid>
  )
}
